import { UserDTO } from './../../models/user.model';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CellAlignmentEnum, ConfigColumn, CustomExportType, EqpTableComponent, ExportEqpTable, TooltipPositionType, TypeColumn } from '@eqproject/eqp-table';
import { TranslateService } from '@ngx-translate/core';
import { CompanyCommercialProductDTO } from '../../models/commercialProduct.model';
import { LookupDTO } from '../../models/lookup.model';
import { ReportCompanyHieracyDTO, ReportGenericCompanyDTO, ReportInvoiceCompanyDTO, ReportInvoiceCompanyFilterDTO } from '../../models/reportList.model';
import { UserListDTO } from '../../models/user.model';
import { CompanyService } from '../../services/company.service';
import { DialogService } from '../../services/dialog.service';
import { LookupService } from '../../services/lookup.service';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { ProductsLimitationsComponent } from '../licenses/products-limitations/products-limitations.component';
import { DocumentListDTO } from '../../models/document.model';
import { DocumentService } from '../../services/document.service';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { FilterConfig, FilterCvlConfig, FilterSizeClass, InputType, WherePartType } from '@eqproject/eqp-filters';


@Component({
  selector: 'app-report-companies',
  templateUrl: './report-companies.component.html',
  styleUrls: ['./report-companies.component.scss']
})
export class ReportCompaniesComponent implements OnInit {

  //allReports: ReportListDTO[];
  reportCompanyHieracy: Array<ReportCompanyHieracyDTO> = new Array<ReportCompanyHieracyDTO>();
  reportGenericCompany: Array<ReportGenericCompanyDTO> = new Array<ReportGenericCompanyDTO>();
  reportInvoiceCompany: Array<ReportInvoiceCompanyDTO> = new Array<ReportInvoiceCompanyDTO>();

  //reportColumns: ConfigColumn[] = [];
  configReportCompanyHieracy: Array<ConfigColumn> = new Array<ConfigColumn>();
  configReportGenericCompany: Array<ConfigColumn> = new Array<ConfigColumn>();
  configReportInvoiceCompany: Array<ConfigColumn> = new Array<ConfigColumn>();

  //reportsExport: ExportEqpTable = { buttonText: this.translate.instant("GENERIC_LABEL.EXPORT"), buttonIcon: "download", tooltipText: this.translate.instant("GENERIC_LABEL.EXPORT"), exportFileName: "CompanyReportList", hiddenColumns: [0], exportFileType: [CustomExportType.CustomXLS, CustomExportType.CustomCSV], customExportFunction: [() => this.exportAllXls(), () => this.exportAllCsv()] }
  exportReportCompanyHieracy: ExportEqpTable = {buttonIcon: "download", tooltipText: this.translate.instant("GENERIC_LABEL.EXPORT_MASK"), exportFileName: "ReportCompanyHieracy", hiddenColumns: [0],  customExportFunction: [() => this.exportReportCompanyHierarchyXls(), () => this.exportReportCompanyHierarchyCsv()] }
  exportReportGenericCompany: ExportEqpTable = {buttonIcon: "download", tooltipText: this.translate.instant("GENERIC_LABEL.EXPORT_MASK"), exportFileName: "ReportGenericCompany", hiddenColumns: [0],  customExportFunction: [() => this.exportReportGenericCompanyXls(), () => this.exportReportGenericCompanyCsv()] }
  exportReportInvoiceCompany: ExportEqpTable = { buttonIcon: "download", tooltipText: this.translate.instant("GENERIC_LABEL.EXPORT_MASK"), exportFileName: "ReportInvoiceCompany", hiddenColumns: [0], customExportFunction: [() => this.exportReportInvoiceCompanyXls()] }

  //Modale visualizzazione utenti azienda
  modalShowUsersRef: MatDialogRef<TemplateRef<any>>;
  @ViewChild('modalShowUsers', { static: true }) modalShowUsers: TemplateRef<any>
  companySelected: string;
  usersColumns: ConfigColumn[] = [];
  usersList: UserListDTO[] = [];

  dialogChangeEmailRef: MatDialogRef<TemplateRef<any>>;
  @ViewChild('dialogChangeEmail', { static: true }) dialogChangeEmail: TemplateRef<any>;
  userSelected: UserListDTO = new UserListDTO();
  newUserEmail: string;

  //#region Proprietà per gestione limitazioni prodotto

  currentFKCompanyHierarchySelected: number = null;
  @ViewChild("dialogCompanyProducts", { static: false }) dialogCompanyProducts: TemplateRef<any>;
  dialogCompanyProductsRef: MatDialogRef<any>;

  //#endregion

  //#region Proprietà per gestione della modifica della relazione

  allCompanyForEditRelation: Array<LookupDTO> = new Array<LookupDTO>();
  currentCompanyParent: LookupDTO = null;
  currentSubCompany: ReportCompanyHieracyDTO = null;
  @ViewChild("dialogCompanyChangeRelation", { static: false }) dialogCompanyChangeRelation: TemplateRef<any>;
  dialogCompanyChangeRelationRef: MatDialogRef<any>;

  //#endregion

  //#region Proprietà per il cambio ID SDI

  @ViewChild("dialogChangeIDSDI", {static : true}) dialogChangeIDSDI : TemplateRef<any>;
  dialogChangeIDSDIRef : MatDialogRef<TemplateRef<any>>;
  documentIdentifier : string;
  alreadySearched : boolean;
  documentRetrieved : DocumentListDTO;
  newIdSDI: string;


  //#endregion

  //#region Filtri
  reportInvoiceCompanyFilter: ReportInvoiceCompanyFilterDTO;
  filters: FilterConfig[];
  resetFilterLabel = this.translate.instant("GENERIC_LABEL.RESET_FILTER");
  //#endregion

  constructor(private reportService: ReportService,
    public translate: TranslateService,
    private dialog: MatDialog,
    private userService: UserService,
    private lookupService: LookupService,
    private companyService: CompanyService,
    private documentService : DocumentService) { }

  ngOnInit(): void {
    this.configureColumns();
    this.loadReportCompanyHierarchy();
    // this.createFilters();
  }

  createFilters() {
    this.filters = [];

    this.reportInvoiceCompanyFilter = new ReportInvoiceCompanyFilterDTO();
    this.reportInvoiceCompanyFilter.AnnoRiferimento = new Date().getFullYear();
    this.reportInvoiceCompanyFilter.FattureProduct = null;
    this.reportInvoiceCompanyFilter.FattureCategory = null;


    let annoRiferimento = FilterConfig.CreateStandardFilterConfig("YEAR_FILTER", "Anno", "AnnoRiferimento", InputType.Number, WherePartType.Equal, FilterSizeClass.SMALL, null,null, null, null, this.reportInvoiceCompanyFilter.AnnoRiferimento, true);

    let fattureProductConfig: FilterCvlConfig = FilterCvlConfig.CreateFilterCVLConfig(null, [{ key: "XLS", value: "XLS" }, { key: "PLUS", value: "PLUS" }], "key", "value", false, false, true, null, false);
    let fattureProduct = FilterConfig.CreateStandardFilterConfig("INVOICE_TYPE_FILTER", "Tipo Fatture", "FattureProduct", InputType.Cvl, WherePartType.Equal, FilterSizeClass.SMALL, fattureProductConfig, null);

    let categoryTypeConfig: FilterCvlConfig = FilterCvlConfig.CreateFilterCVLConfig(null, [{ key: "Attiva", value: "Attiva" }, { key: "Passiva", value: "Passiva" }], "key", "value", false, false, true, null, false);
    let fattureCategory = FilterConfig.CreateStandardFilterConfig("INVOICE_CATEGORY_FILTER", "Categorie Fatture", "FattureCategory", InputType.Cvl, WherePartType.Equal, FilterSizeClass.SMALL, categoryTypeConfig, null);


    this.filters.push(annoRiferimento);
    this.filters.push(fattureProduct);
    this.filters.push(fattureCategory);

  }

  filtersSelected(event) {


    if (event != null) {
      this.reportInvoiceCompanyFilter.AnnoRiferimento = event.AnnoRiferimento != null ? event.AnnoRiferimento : new Date().getFullYear();

      if(this.filters != null && this.filters.length > 0 && this.filters[0] != null && event.AnnoRiferimento == null)
        this.filters[0].PropertyObject = new Date().getFullYear();

      this.reportInvoiceCompanyFilter.FattureProduct = event.FattureProduct;
      this.reportInvoiceCompanyFilter.FattureCategory = event.FattureCategory;
    }
    else {
      this.reportInvoiceCompanyFilter.AnnoRiferimento = new Date().getFullYear();

      if(this.filters != null && this.filters.length > 0 && this.filters[0] != null)
        this.filters[0].PropertyObject = new Date().getFullYear();

      this.reportInvoiceCompanyFilter.FattureProduct = null;
      this.reportInvoiceCompanyFilter.FattureCategory = null;
    }

    this.loadReportInvoiceCompany(this.reportInvoiceCompanyFilter)

  }



  selectedMatTabChanged(event : MatTabChangeEvent){
    switch(event.index) {
      case 1: {
        if(this.reportGenericCompany == null || this.reportGenericCompany.length == 0)
          this.loadReportGenericCompany();
        break;
      }
      case 2: {
        if (this.reportInvoiceCompany == null || this.reportInvoiceCompany.length == 0)
          // this.loadReportInvoiceCompany(this.reportInvoiceCompanyFilter);
          this.createFilters();
        break;
      }
      default: {
        break;
      }
    }
  }

  loadReportCompanyHierarchy() {
    this.reportService.getReportCompanyHierarchy().then(res => {
      this.reportCompanyHieracy = res;
    }).catch(e => {
      DialogService.Error(e.message);
    })
  }

  loadReportGenericCompany() {
    this.reportService.getReportGenericCompany().then(res => {
      this.reportGenericCompany = res;
    }).catch(e => {
      DialogService.Error(e.message);
    })
  }

  loadReportInvoiceCompany(filters: ReportInvoiceCompanyFilterDTO) {
    this.reportService.getFilteredReportInvoiceCompany(filters).then(res => {
      this.reportInvoiceCompany = res;
    }).catch(e => {
      DialogService.Error(e.message);
    })
  }


  configureColumns() {
    this.configReportCompanyHieracy = [
      {
        key: 'attachment',
        display: '',
        buttonMenuIcon: 'more_vert',
        type: TypeColumn.MenuAction,
        styles: { flex: '0 0 5%' },
        actions: [
          /*{
            icon: 'visibility',
            name: this.translate.instant("GENERIC_LABEL.SHOW_USERS_COMPANY"),
            disabled: (element) => element.RelationLiv1ID == 0,
            fn: (element) => this.viewRow(element)
          },*/
          {
            icon: 'edit',
            name: this.translate.instant("GENERIC_LABEL.EDIT_RELATION"),
            disabled: (element) => { return element.ParentRelationId == null || element.ParentRelationId == undefined },
            fn: (element) => this.openModalChangeCompanyRelation(element)
          },
          /*
          {
            icon: 'check',
            name: this.translate.instant("GENERIC_LABEL.ENABLE_ALL_USERS"),
            fn: (element) => this.setStatusForAllCompanyUsers(element, true)
          },
          {
            icon: 'close',
            name: this.translate.instant("GENERIC_LABEL.DISABLE_ALL_USERS"),
            fn: (element) => this.setStatusForAllCompanyUsers(element, false)
          },
          */
          {
            name: this.translate.instant("GENERIC_LABEL.LIMITATIONS"),
            icon: "remove_circle",
            fn: (element) => this.showCompanyProducts(element),
            disabled: (element) => element.RelationLiv1ID == 0,
            tooltip: { tooltipText: this.translate.instant("GENERIC_LABEL.SET_LIMITATIONS"), tooltipPosition: TooltipPositionType.Above }
          }
        ]
      },
      { key: 'Azienda', display: this.translate.instant('GENERIC_FIELDS.COMPANY'), styles: { flex: '0 0 15%' } },
      { key: 'Livello', display: this.translate.instant("GENERIC_FIELDS.COMMERCIAL_LEVEL") },
      { key: 'Email', display: this.translate.instant("GENERIC_FIELDS.EMAIL"), styles: { flex: '0 0 18%' } },
      { key: 'VatNumber', display: this.translate.instant("GENERIC_FIELDS.VATNUMBER"), styles: { flex: '0 0 10%' } },
      { key: 'Tipo', display: this.translate.instant("GENERIC_FIELDS.TYPE") },      
      { key: 'LicencesAvailable', display: this.translate.instant("GENERIC_FIELDS.LICENCES_AVAILABLE"), styles: { flex: '0 0 15%', cellAlignment: CellAlignmentEnum.CENTER } },
      { key: 'AziendaLiv1', display: this.translate.instant("GENERIC_FIELDS.FIRST_LEVEL_COMPANY") },
      { key: 'AziendaLiv2', display: this.translate.instant("GENERIC_FIELDS.SECOND_LEVEL_COMPANY") },
      { key: 'AziendaLiv3', display: this.translate.instant("GENERIC_FIELDS.THIRD_LEVEL_COMPANY") },      
      {
        key: "Enabled",
        display: this.translate.instant("GENERIC_LABEL.STATE"),
        type: TypeColumn.Boolean,
        booleanValues: {
          true: '<i class="fa fa-check success-color"></i>',
          false: '<i class="fa fa-close error-color"></i>'
        },
        styles: { flex: "0 0 5%" }
      }
    ];

    this.configReportGenericCompany = [
      { key: 'IDLegalEntity', display: 'IDLegalEntity' },
      { key: 'IDCliente', display: 'ID', styles: { flex: '0 0 5%' } },
      { key: 'Denominazione', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION"), styles: { flex: '0 0 20%', cellAlignment: CellAlignmentEnum.CENTER } },
      { key: 'PartitaIva', display: this.translate.instant("GENERIC_FIELDS.VATNUMBER"), styles: { flex: '0 0 10%' } },
      { key: 'RegimeFiscale', display: this.translate.instant("GENERIC_FIELDS.TAXREGIME") },
      { key: 'Rivenditore', display: this.translate.instant("GENERIC_LABEL.RIVENDITORE") },
      { key: 'Tipo', display: this.translate.instant("GENERIC_FIELDS.TYPE") },
      { key: 'DataAttivazione', display: this.translate.instant("GENERIC_FIELDS.ACTIVATED_DATE"), type: TypeColumn.Date, format: 'dd/MM/yyyy' },
      { key: 'DataDisattivazione', display: this.translate.instant("GENERIC_FIELDS.DISACTIVATED_DATE"), type: TypeColumn.Date, format: 'dd/MM/yyyy' },
      { key: 'CountUtenti', display: '#' + this.translate.instant("SECTIONS.USERS") },
      { key: 'Email', display: this.translate.instant("GENERIC_FIELDS.EMAIL"), styles: { flex: '0 0 10%' } },
      { key: 'Telefono', display: this.translate.instant("GENERIC_FIELDS.TELEPHONE"), styles: { flex: '0 0 10%', cellAlignment: CellAlignmentEnum.RIGHT } },
      {
        key: "Shop",
        display: "Shop",
        type: TypeColumn.Boolean,
        booleanValues: {
          true: '<i class="fa fa-check success-color"></i>',
          //null: '',
          false: ''
        },
        styles: { flex: "0 0 5%" }
      },
      {
        key: "Forfettario",
        display: "Forfettario",
        type: TypeColumn.Boolean,
        booleanValues: {
          true: '<i class="fa fa-check success-color"></i>',
          //false: '<i class="fa fa-close error-color"></i>'
          false: ''
        },
        styles: { flex: "0 0 5%" }
      }

      
    ];

    this.configReportInvoiceCompany = [
      { key: 'IDCliente', display: 'ID', styles: { flex: '0 0 5%' } },
      { key: 'Denominazione', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION"), styles: { flex: '0 0 20%', cellAlignment: CellAlignmentEnum.CENTER } },
      { key: 'PartitaIva', display: this.translate.instant("GENERIC_FIELDS.VATNUMBER"), styles: { flex: '0 0 10%' } },
      { key: 'Anno', display: this.translate.instant("GENERIC_FIELDS.YEAR") },
      { key: 'Mese', display: this.translate.instant("GENERIC_FIELDS.MONTH") },
      { key: 'CountInvoice', display: this.translate.instant("GENERIC_FIELDS.COUNT_INVOICE") },
      { key: 'TipoProdotto', display: this.translate.instant("GENERIC_FIELDS.PRODUCT_TYPE") },
      { key: 'TipoFattura', display: this.translate.instant("GENERIC_FIELDS.INVOICE_TYPE") },
      { key: 'CategoriaFattura', display: this.translate.instant("GENERIC_FIELDS.INVOICE_CATEGORY") },
    ];




    this.usersColumns = [
      {
        key: 'attachment',
        display: '',
        buttonMenuIcon: 'more_vert',
        type: TypeColumn.MenuAction,
        styles: { flex: '0 0 7%', cellAlignment: CellAlignmentEnum.CENTER },
        actions: [
          {
            icon: 'edit',
            name: this.translate.instant("GENERIC_LABEL.CHANGE_EMAIL"),
            fn: (element) => this.openChangeUserEmail(element)
          },
          {
            icon: 'autorenew',
            name: this.translate.instant("GENERIC_LABEL.RESET_PASSWORD"),
            fn: (element) => this.resetPassword(element)
          }
        ]
      },
      { key: 'Name', display: 'Nome', styles: { flex: '0 0 30%' } },
      { key: 'Surname', display: 'Cognome', styles: { flex: '0 0 30%' } },
      { key: 'Email', display: 'Email', styles: { flex: '0 0 33%' } }
    ]


  }

  resetPassword(element){
    DialogService.Confirm(this.translate.instant("GENERIC_LABEL.RESET_PASSWORD_TO_123456"), () => {
      this.userService.resetToDefaultPassword(element.ID).then(() => {
        DialogService.Success(this.translate.instant("DIALOGS.PASSWORD_MODIFIED_SUCCESS"));
      }).catch(err => {
        DialogService.Error(err.message);
      });
    });
  }

  async viewRow(element: ReportCompanyHieracyDTO) {
    this.companySelected = element.Azienda;
    this.usersList = await this.userService.getUsersByCompany(element.FK_Company);

    this.modalShowUsersRef = this.dialog.open(this.modalShowUsers, {
      disableClose: false,
      hasBackdrop: true,
      maxWidth: '80%',
      minHeight: '300px',
    })
  }

  editRow(element) {

  }

  exportReportCompanyHierarchyXls() {
    this.reportService.exportReportCompanyHierarchyXls();
  }

  exportReportCompanyHierarchyCsv() {
    this.reportService.exportReportCompanyHierarchyCsv();
  }

  exportReportGenericCompanyXls() {
    this.reportService.exportReportGenericCompanyXls();
  }

  exportReportGenericCompanyCsv() {
    this.reportService.exportReportGenericCompanyCsv();
  }

  exportReportInvoiceCompanyXls() {

    this.reportService.exportReportInvoiceCompanyXls(this.reportInvoiceCompanyFilter);
  }

  exportReportInvoiceCompanyCsv() {
    this.reportService.exportReportInvoiceCompanyCsv();
  }

  //#region Gestione attivazione/disattivazione di tutti gli utenti dell'azienda

  setStatusForAllCompanyUsers(element: ReportCompanyHieracyDTO, enableStatus: boolean) {
    let statusToSet = enableStatus;
    let fk_company = element.FK_Company;
    let confirmMessage = enableStatus == true ? this.translate.instant("DIALOGS.CONFIRM_ENABLE_ALL_USERS") : this.translate.instant("DIALOGS.CONFIRM_DISABLE_ALL_USERS");
    DialogService.Confirm(confirmMessage, () => {
      this.userService.setStatusForAllCompanyUsers(fk_company, statusToSet)
        .then((res) => {
          DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"), null, true);
          this.loadReportCompanyHierarchy();
        })
        .catch((err) => {
          DialogService.Error(err.message);
        })
    });
  }

  //#endregion

  //#region Gestione limitazioni su licenza

  /**
   * Funzione richiamata quando viene premuto il tasto relativo alle limitazioni da impostare per un prodotto commerciale
   * @param item Item che identifica la riga di licenza per cui impostare le limitazioni
   */
  showCompanyProducts(item: ReportCompanyHieracyDTO) {
    this.currentFKCompanyHierarchySelected = item.FK_Company;
    this.dialogCompanyProductsRef = this.dialog.open(this.dialogCompanyProducts, {
      disableClose: false,
      hasBackdrop: true,
      minHeight: '40%',
      width: '70%'
    })
  }

  /**
   * Funzione richiamato dall'evento di output presente sul componente ProductsLimitationComponente, alla conferma dell'applicazione della limitazione sulla licenza
   * @param limitation
   */
  companyProductsClosed() {
    this.dialogCompanyProductsRef.close();
    this.currentFKCompanyHierarchySelected = null;
  }

  //#endregion

  //#region Gestione modifica relazione aziende  
  async openModalChangeCompanyRelation(item: ReportCompanyHieracyDTO) {
    if (!item || !item.ParentRelationId)
      return;
     
    let userauth;
    await this.userService.UserAuthorized(item.FK_Company).then(res => {
      userauth = res;
    })

    if (!userauth) {
      DialogService.Error("Non sei autorizzato a modificare la relazione di questa azienda");
      return;
    }
            

    this.allCompanyForEditRelation = await this.lookupService.GetCompanyLookupEntities();
    this.currentCompanyParent = this.allCompanyForEditRelation.find(c => c.ID == item.IDAziendaLiv1);
    this.currentSubCompany = item;

    this.dialogCompanyChangeRelationRef = this.dialog.open(this.dialogCompanyChangeRelation, {
      disableClose: false,
      hasBackdrop: true,
      minHeight: '50%',
      width: '40%'
    });
  }

  confirmCompanyChangeRelation() {
    if (this.currentCompanyParent == null) {
      DialogService.Error(this.translate.instant("DIALOGS.COMPANY_NOT_SELECTED"));
      return;
    }

    DialogService.Confirm(this.translate.instant("DIALOGS.CONFIRM_COMPANY_EDIT_RELATION"), () => {
      this.companyService.changeCompanyRelation(this.currentSubCompany.FK_Company, <number>this.currentCompanyParent.ID)
        .then((res) => {
          DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"), null, true);
          this.loadReportCompanyHierarchy();
          this.dialogCompanyChangeRelationRef.close();
        })
        .catch((err) => {
          DialogService.Error(err.message);
        })
    });
  }

  openChangeUserEmail(element) {
    this.userSelected = element;
    this.newUserEmail = null;

    this.dialogChangeEmailRef = this.dialog.open(this.dialogChangeEmail, {
      disableClose: false,
      hasBackdrop: true,
      maxWidth: '80%',
      minHeight: '300px',
    })
  }

  changeUserEmail() {

    if (this.newUserEmail == null || this.newUserEmail == "")
      return;

    this.userService.updateUserEmails(this.userSelected.ID, this.newUserEmail)
      .then(async (res) => {
        DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"), null, true);
        this.dialogChangeEmailRef.close();
        this.usersList = await this.userService.getUsersByCompany(this.userSelected.FK_Company);
      })
      .catch((err) => {
        DialogService.Error(err.message);
      })
  }

  //#endregion

  //#region Regione per cambio ID SDI

  /**
   * Metodo per l'apertura della modale relativa al cambio ID SDI
   */
  openChangeIDSDIModal(){
    this.documentIdentifier = "";
    this.dialogChangeIDSDIRef = this.dialog.open(this.dialogChangeIDSDI, {
      disableClose: false,
      hasBackdrop: true,
      maxWidth: '80%',
      minHeight: '220px',
    });
  }

  /**
   * Metodo per la ricerca del documento tramite l'identificativo inserito nella modale
   */
  searchByIdentifier(){
    let id = Number.parseInt(this.documentIdentifier);
    if(!Number.isNaN(id))
      this.documentService.getLite(id).then(res => {
        this.alreadySearched = true;
        this.documentRetrieved = res;
        this.newIdSDI = "";
      }).catch(err => {
        DialogService.Error(err.message);
      })
    else
      DialogService.Error(this.translate.instant("DIALOGS.INVALID_IDENTIFIER"));
  }

  /**
   * Metodo per il cambio dell'ID SDI
   * Chiama un API che, passando ID e nuovo IDSDI, effettua il cambio
   */
  changeIDSDI(){
    this.documentService.updateIDsdiFEDocuments(this.documentRetrieved.ID, this.newIdSDI).then(() => {
      DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"));
      this.closeChangeIDSDIModal();
    }).catch(err => {
      DialogService.Error(err.message);
    })
  }

  closeChangeIDSDIModal(){
   this.alreadySearched = false;
   this.dialogChangeIDSDIRef.close();
  }

  //#endregion
}
